import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {TimelineSprite} from "@nolimitcity/slot-launcher/bin/animation/TimelineSprite";
import {TimelineLite, TweenLite} from "gsap";
import {PearlHarborHelper} from "../utils/PearlHarborHelper";
import {PearlHarbor} from "../PearlHarbor";

export class PearlHarborLuckyDrawAnimation extends PIXI.Container implements StageLayer {
    private _fullBackground: PIXI.Graphics;
    private _title: PIXI.Sprite;
    private _glows: PIXI.Sprite[] = [];
    private _allFeatureLayout: PIXI.Sprite[] = [];
    private _fireFrameBlast: TimelineSprite;
    private _toggleFrame: PIXI.Sprite;
    private _animTl: TimelineLite;

    constructor() {
        super();
        this.name = "LUCKY_DRAW_ANIMATION";
        this.visible = false;
        //this.init();
    }

    private init(): void {
        this._fullBackground = new PIXI.Graphics();
        this._fullBackground.beginFill(0x000000, 0.65);
        this._fullBackground.drawRect(-480, -480, 1680, 1680);
        this._fullBackground.endFill();
        this._fullBackground.visible = false;

        this._title = new PIXI.Sprite(PearlHarbor.assetLoader.getTextures("luckyDrawTitle")[0]);
        this._title.visible = false;
        this._title.blendMode = PIXI.BLEND_MODES.SCREEN;
        this._title.scale.set(0.6);
        this._title.anchor.set(0.5);
        this._title.position.set(360, 150);

        this.addChild(this._fullBackground, this._title);

        this.createLayout();

        this._toggleFrame = new PIXI.Sprite(PearlHarbor.assetLoader.getTextures("luckyDrawGlow")[0]);
        this._toggleFrame.anchor.set(0.5);
        this._toggleFrame.visible = false;
        this._toggleFrame.scale.set(1.4);
        this._toggleFrame.blendMode = PIXI.BLEND_MODES.SCREEN;

        this._fireFrameBlast = new TimelineSprite(PearlHarbor.assetLoader.getTextures("luckyDrawFireFrameBlast"));
        this._fireFrameBlast.anchor.set(0.5);
        this._fireFrameBlast.hide();
        this._fireFrameBlast.scale.set(3, 2.4);
        this._fireFrameBlast.blendMode = PIXI.BLEND_MODES.SCREEN;

        this.addChild(this._toggleFrame, this._fireFrameBlast);
    }

    private createLayout(): void {
        const centre: number = 360,
            gap: number = 30,
            stdFS: PIXI.Sprite = new PIXI.Sprite(PearlHarbor.assetLoader.getTextures("luckyDrawStdFS")[0]),
            stdFSGlow: PIXI.Sprite = new PIXI.Sprite(PearlHarbor.assetLoader.getTextures("luckyDrawGlow")[0]),
            coolFS: PIXI.Sprite = new PIXI.Sprite(PearlHarbor.assetLoader.getTextures("luckyDrawCoolFS")[0]),
            coolFSGlow: PIXI.Sprite = new PIXI.Sprite(PearlHarbor.assetLoader.getTextures("luckyDrawGlow")[0]),
            superFS: PIXI.Sprite = new PIXI.Sprite(PearlHarbor.assetLoader.getTextures("luckyDrawSuperFS")[0]),
            superFSGlow: PIXI.Sprite = new PIXI.Sprite(PearlHarbor.assetLoader.getTextures("luckyDrawGlow")[0]);

        stdFS.anchor.set(0.5);
        stdFSGlow.anchor.set(0.5);
        coolFS.anchor.set(0.5);
        coolFSGlow.anchor.set(0.5);
        superFS.anchor.set(0.5);
        superFSGlow.anchor.set(0.5);

        coolFS.x = centre;
        stdFS.x = (centre - coolFS.width - gap);
        superFS.x = (centre + coolFS.width + gap);

        this._glows.push(stdFSGlow, coolFSGlow, superFSGlow);
        this._allFeatureLayout.push(stdFS, coolFS, superFS);
        this._allFeatureLayout.forEach((sprite: PIXI.Sprite, index: number) => {
            const glow: PIXI.Sprite = this._glows[index];
            glow.scale.set(1.4);
            glow.blendMode = PIXI.BLEND_MODES.SCREEN;
            glow.visible = false;

            sprite.y = centre;
            sprite.visible = false;

            glow.position = sprite.position;

            this.addChild(glow, sprite);
        });
    }

    public playAnimation(index: number): TimelineLite {
        if (this._animTl) {
            this._animTl.totalProgress(1);
            this._animTl.clear();
        }

        const randomPos: number[] = [index]; // to toggle randomly

        for (let count: number = 0; count < 3; count++) {
            let generatedNumber: number = PearlHarborHelper.getRandomIntInRange(0, 2);
            if (randomPos.length) {
                while (generatedNumber === randomPos[0]) {
                    generatedNumber = PearlHarborHelper.getRandomIntInRange(0, 2);
                }
                randomPos.unshift(generatedNumber);
            }
        }

        [this._fullBackground, this._title].forEach((value: PIXI.DisplayObject) => {
            value.alpha = 0;
            value.visible = true;
        });
        this._allFeatureLayout.forEach((value: PIXI.Sprite, index: number) => {
            value.tint = 0xffffff;
            value.alpha = 0;
            value.visible = true;

            this._glows[index].alpha = 0;
            this._glows[index].visible = true;
        });
        this._toggleFrame.visible = false;
        this._fireFrameBlast.position.set((this._allFeatureLayout[index].position.x) - 10, (this._allFeatureLayout[index].position.y) - 20);

        this._animTl = new TimelineLite({
            paused: true
        });

        this._animTl.add([
            TweenLite.to([this._fullBackground, this._title, this._allFeatureLayout], {
                duration: 0.5,
                alpha: 1
            }),
            TweenLite.to(this._glows, {
                duration: 0.5,
                alpha: 0.5
            })
        ])

        for (let idx: number = 0; idx < randomPos.length; idx++) {
            this._animTl.add(() => {
                this._toggleFrame.position.set(this._allFeatureLayout[randomPos[idx]].position.x - 5, this._allFeatureLayout[randomPos[idx]].position.y);
                this._toggleFrame.visible = true;
                this._toggleFrame.alpha = 1;
            });
            // so that toggle frame stays on the result
            if (idx < randomPos.length - 1) {
                this._animTl.to(this._toggleFrame, {
                    duration: 0.2,
                    alpha: 0
                });
            }
        }

        this._animTl.add(() => {
            for (let idx: number = 0; idx < this._allFeatureLayout.length; idx++) {
                if (idx !== index) {
                    this._allFeatureLayout[idx].tint = 0x555555;

                    // no need to add this time
                    TweenLite.to(this._glows[idx], {
                        duration: 0.1,
                        alpha: 0
                    });
                }
            }
        });
        this._animTl.add(this._fireFrameBlast.getAnimationAutoShowHide(true, true));
        this._animTl.to(this, {duration: 1}); // let it stay there

        // let it fade out but add less(fade out time is not added in tl), so that fade out is bit of overlapped with spin.
        this._animTl.add(() => {TweenLite.to([this._fullBackground, this._title, this._glows, this._toggleFrame, this._allFeatureLayout], {
            duration: 0.35,
            alpha: 0
        })});

        this._animTl.add(() => {
            [this._fullBackground, this._title, this._toggleFrame].forEach((value: PIXI.DisplayObject) => value.visible = false);
            this._allFeatureLayout.forEach((value: PIXI.Sprite, index: number) => {
                value.visible = false;
                this._glows[index].visible = false;
            });
            this._fireFrameBlast.hide();
        });
        return this._animTl.play(0);
    }
}